module.exports = __webpack_public_path__ + "img/copy.8788f5dc.svg";